// Publications list: insert a year heading each time the year changes.
export default function publications() {
    document.querySelectorAll("[data-group-by-year]").forEach((list) => {
        let year = null;
        Array.from(list.querySelectorAll(".gh-pub")).forEach((pub) => {
            const y = pub.getAttribute("data-year");
            if (y && y !== year) {
                year = y;
                const h = document.createElement("h2");
                h.className = "gh-pub-year";
                h.textContent = y;
                list.insertBefore(h, pub);
            }
        });
    });
}
